import { createUseStyles } from 'react-jss';

import { ITheme } from 'types';

import { overlayStyles } from '../defaultStyles';

const useStyles = createUseStyles((theme: ITheme) => ({
  confirmModal: {
    position: 'absolute',
    left: '50%',
    top: '50%',
    transform: 'translate(-50%, -50%)',
    display: 'grid',
    gridGap: theme.spacings.s16,
    maxWidth: 500,
    width: 'calc(100% - 48px)',
    maxHeight: '90vh',
    padding: theme.spacings.s32,
    border: `2px solid ${theme.colors.backgrounds.tint3}`,
    borderRadius: theme.radiuses.r8,
    backgroundColor: theme.colors.backgrounds.tint2,
    boxShadow: `0 0 8px ${theme.colors.shadows.tint1}`,
    overflow: 'auto',
  },
  confirmModalOverlay: overlayStyles,
  close: {
    position: 'absolute',
    right: theme.spacings.s12,
    top: theme.spacings.s12,
    cursor: 'pointer',
    color: theme.colors.texts.negative,
    verticalAlign: 'top',
    display: 'inline-block',
    backgroundColor: theme.colors.backgrounds.tint5,
    borderRadius: theme.radiuses.circle,
    width: 20,
    height: 20,
    '& path': {
      fill: theme.colors.backgrounds.base,
    },
  },
  confirmModalChoice: {
    display: 'grid',
    gridAutoFlow: 'column',
    justifyContent: 'end',
    gap: theme.spacings.s12,
    marginTop: theme.spacings.s16,
  },

}));

export default useStyles;
